export const getProducts = ({ productReducer: { products = [] } = {} }) =>
  products;
export const getProductFilter = ({ productReducer: { filter = {} } = {} }) =>
  filter;
export const getProductCount = ({ productReducer: { count = 0 } = {} }) =>
  count;
export const getCategorieList = ({
  productReducer: { categories = [] } = {},
}) => categories;
